<template>
    <el-col :xs="24" :md="12" :cols="12">
        <div v-loading="loading" id="colderecha">
            <template v-if="!preview.length">
                <h2>Enviar archivo</h2>
                <div
                    :style="`width: 360px; height: ${0 + (33 * files.length)}px; max-height: 132px; overflow-y: auto; padding: 0px 10px 0px 10px; margin: 10px 0 10px 0; transition: 0.5s`">
                    <div v-for="archivo in files" :key="archivo.file.name"
                        :class="`documento ${archivo.tipo} ${archivo.tipo == 'error' ? 'apply-shake' : ''}`">
                        <font-awesome-icon v-if="archivo.icon != 'loading'" :icon="getIconPath(archivo.file.name)" />
                        <i v-else class="el-icon-loading"></i>
                        {{ archivo.file.name }}
                    </div>
                </div>
                <h2>Opciones de documento</h2>
                <ul class="contenedoraplicaciones">
                    <li @click="cargarNomina('dividir')" class="tipodocumento">
                        <div style="display:flex">
                            <div class="icono">
                                <img src="@/assets/flechas.png" width="70%" />
                            </div>
                            <p><b>Dividir documento</b></p>
                        </div>
                        <hr />
                        <span>Escanea un PDF con todas las nóminas y las separa individualmente.</span>
                    </li>
                    <!-- <li @click="cargarNomina('zip')" class="tipodocumento">
                        <div style="display:flex">
                            <div class="icono">
                                <img src="@/assets/archivo-zip.png" width="70%" />
                            </div>
                            <p><b>Extraer ZIP</b></p>
                        </div>
                        <hr />
                        <span>Extrae un ZIP con todas las nóminas y las reparte individualmente.</span>
                    </li>
                    <li @click="cargarNomina('individual')" class="tipodocumento">
                        <div style="display:flex">
                            <div class="icono">
                                <img src="@/assets/pdf.png" width="70%" />
                            </div>
                            <p><b>Individual</b></p>
                        </div>
                        <hr />
                        <span>Carga una sola nómina y se repartirá a quien figure en ella.</span>
                    </li> -->
                </ul>
                <el-button type="primary" @click="$router.back()">Volver</el-button>
            </template>
            <template v-else>
                <h2>Previsualizar resultado</h2>
                <div class="preview-container">
                    <div class="navigation-controls">
                        <el-button @click="currentPreviewIndex = 0; loadNomina(currentPreviewIndex)" circle>
                            <font-awesome-icon icon="fas fa-angles-left" />
                        </el-button>
                        <el-button @click="prevNomina" :disabled="currentPreviewIndex === 0" circle>
                            <font-awesome-icon icon="fas fa-angle-left" />
                        </el-button>
                        <span>Nómina {{ currentPreviewIndex + 1 }} de {{ preview.length }}</span>
                        <el-button @click="nextNomina" :disabled="currentPreviewIndex === preview.length - 1" circle>
                            <font-awesome-icon icon="fas fa-angle-right" />
                        </el-button>
                        <el-button @click="currentPreviewIndex = preview.length - 1; loadNomina(currentPreviewIndex)" circle>
                            <font-awesome-icon icon="fas fa-angles-right" />
                        </el-button>
                    </div>
                    <div
                        :style="`border-radius: 5px; margin-bottom: 20px; width: ${preview[currentPreviewIndex].width}px; color:white; background-color: ${preview[currentPreviewIndex].name ? '#27ae60' : '#c0392b'}`">
                        <div style="padding: 10px;">
                            <b>Nombre: </b> {{ preview[currentPreviewIndex].name ?? 'Usuario no encontrado' }}<br>
                            <b>Email: </b> {{ preview[currentPreviewIndex].email ?? 'Usuario no encontrado' }}<br>
                            <b>DNI: </b> {{ preview[currentPreviewIndex].dni ?? 'Usuario no encontrado' }}<br>
                        </div>
                    </div>
                    <div style="max-height: 60dvh; overflow: auto; margin-bottom: 20px;">
                        <canvas ref="canvas" class="canvas-preview"></canvas>
                    </div>
                    <div class="page-controls">
                        <el-button @click="prevPage" :disabled="currentPage === 1" circle>
                            <font-awesome-icon icon="fas fa-angle-left" />
                        </el-button>
                        <span>Página {{ currentPage }} de {{ totalPages }}</span>
                        <el-button @click="nextPage" :disabled="currentPage === totalPages" circle>
                            <font-awesome-icon icon="fas fa-angle-right" />
                        </el-button>
                    </div>
                    <el-button v-if="currentPreviewIndex + 1 != preview.length" @click="sendPreview = true; volver()" type="primary" style="margin-top: 10px">
                        Volver a datos
                    </el-button>
                    <el-button v-else @click="sendPreview = false; cargarNomina()" type="success" style="margin-top: 10px">
                        Finalizar revisión
                    </el-button>
                </div>
            </template>
        </div>
    </el-col>
</template>

<script>
import { mapMutations } from "vuex";
import { mapState } from "vuex";

export default {
    name: "EnviarNominas",
    data() {
        return {
            loading: false,
            currentPreviewIndex: 0,
            currentPage: 1,
            totalPages: 0,
            preview: [],
            sendPreview: true,
        };
    },
    computed: mapState(["files"]),
    methods: {
        ...mapMutations(["setFiles"]),
        async cargarNomina(accion) {
            this.loading = true;
            const formData = new FormData();
            this.files.forEach((file, index) => {
                formData.append(`file${index}`, file.file);
            });
            formData.append("accion", accion);
            formData.append("preview", this.sendPreview);

            try {
                const response = await fetch(
                    `${process.env.VUE_APP_PORTAL}/api/nominas/enviarNominas`,
                    {
                        method: "POST",
                        body: formData,
                    }
                );

                if (response.ok) {
                    if(this.sendPreview) {
                    const data = await response.json();
                    this.preview = data.map((nomina) => ({
                        pdfData: nomina.nomina,
                        pdf: null,
                        currentPage: 1,
                        totalPages: 0,
                        name: nomina.name,
                        email: nomina.email,
                        dni: nomina.dni
                    }));
                    await this.loadNomina(0);
                    this.previewMode = true;
                } else {
                    this.$notify({
                        title: "Éxito",
                        message: "Nóminas enviadas correctamente",
                        type: "success",
                    })
                    this.setFiles([]);
                    this.$router.push('/dashboard')
                }
                } else {
                    this.$notify({
                        title: "Error",
                        message: "Error procesando las nóminas",
                        type: "error",
                    });
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },
        async loadNomina(index) {
            const pdfjsLib = window["pdfjs-dist/build/pdf"];
            const loadingTask = pdfjsLib.getDocument({
                data: atob(this.preview[index].pdfData),
            });
            this.preview[index].pdf = await loadingTask.promise;
            this.totalPages = this.preview[index].pdf.numPages;
            this.currentPage = 1;
            this.renderPage();
        },
        async renderPage() {
            const nomina = this.preview[this.currentPreviewIndex];
            const page = await nomina.pdf.getPage(this.currentPage);
            const viewport = page.getViewport({ scale: 1 });
            const canvas = this.$refs.canvas;
            const context = canvas.getContext("2d");
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            nomina.width = canvas.width;
            const renderContext = {
                canvasContext: context,
                viewport: viewport,
            };
            await page.render(renderContext).promise;
        },
        nextNomina() {
            if (this.currentPreviewIndex < this.preview.length - 1) {
                this.currentPreviewIndex++;
                this.loadNomina(this.currentPreviewIndex);
            }
        },
        prevNomina() {
            if (this.currentPreviewIndex > 0) {
                this.currentPreviewIndex--;
                this.loadNomina(this.currentPreviewIndex);
            }
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
                this.renderPage();
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.renderPage();
            }
        },
        volver() {
            this.preview = [];
            this.previewMode = false;
        },
        getIconPath(nombreArchivo) {
            let img = '';
            let ext = nombreArchivo.split('.').pop();
            switch (ext) {
                case 'ico':
                case 'gif':
                case 'jpg':
                case 'jpeg':
                case 'jpc':
                case 'jp2':
                case 'jpx':
                case 'xbm':
                case 'wbmp':
                case 'png':
                case 'bmp':
                case 'tif':
                case 'tiff':
                case 'webp':
                case 'avif':
                case 'svg':
                    img = 'fa-regular fa-image';
                    break;
                case 'passwd':
                case 'ftpquota':
                case 'sql':
                case 'js':
                case 'json':
                case 'sh':
                case 'config':
                case 'twig':
                case 'tpl':
                case 'md':
                case 'gitignore':
                case 'c':
                case 'cpp':
                case 'cs':
                case 'py':
                case 'rs':
                case 'map':
                case 'lock':
                case 'dtd':
                    img = 'fa-regular fa-file-code';
                    break;
                case 'txt':
                case 'ini':
                case 'conf':
                case 'log':
                case 'htaccess':
                case 'yaml':
                case 'yml':
                case 'toml':
                    img = 'fa-regular fa-file-lines';
                    break;
                case 'css':
                case 'less':
                case 'sass':
                case 'scss':
                    img = 'fa-brands fa-css3-alt';
                    break;
                case 'bz2':
                case 'zip':
                case 'rar':
                case 'gz':
                case 'tar':
                case '7z':
                case 'xz':
                    img = 'fa-regular fa-file-zipper';
                    break;
                case 'php':
                case 'php4':
                case 'php5':
                case 'phps':
                case 'phtml':
                    img = 'fa-solid fa-code';
                    break;
                case 'htm':
                case 'html':
                case 'shtml':
                case 'xhtml':
                    img = 'fa-brands fa-html5';
                    break;
                case 'xml':
                case 'xsl':
                    img = 'fa-regular fa-file-excel';
                    break;
                case 'wav':
                case 'mp3':
                case 'mp2':
                case 'm4a':
                case 'aac':
                case 'ogg':
                case 'oga':
                case 'wma':
                case 'mka':
                case 'flac':
                case 'ac3':
                case 'tds':
                    img = 'fa-solid fa-music';
                    break;
                case 'm3u':
                case 'm3u8':
                case 'pls':
                case 'cue':
                case 'xspf':
                    img = 'fa-solid fa-headphones';
                    break;
                case 'avi':
                case 'mpg':
                case 'mpeg':
                case 'mp4':
                case 'm4v':
                case 'flv':
                case 'f4v':
                case 'ogm':
                case 'ogv':
                case 'mov':
                case 'mkv':
                case '3gp':
                case 'asf':
                case 'wmv':
                case 'webm':
                    img = 'fa-regular fa-file-video';
                    break;
                case 'eml':
                case 'msg':
                    img = 'fa-regular fa-envelope';
                    break;
                case 'xls':
                case 'xlsx':
                case 'ods':
                    img = 'fa-regular fa-file-excel';
                    break;
                case 'csv':
                    img = 'fa-regular fa-file-lines';
                    break;
                case 'bak':
                case 'swp':
                    img = 'fa-regular fa-clipboard';
                    break;
                case 'doc':
                case 'docx':
                case 'odt':
                    img = 'fa-regular fa-file-word';
                    break;
                case 'ppt':
                case 'pptx':
                    img = 'fa-regular fa-file-powerpoint';
                    break;
                case 'ttf':
                case 'ttc':
                case 'otf':
                case 'woff':
                case 'woff2':
                case 'eot':
                case 'fon':
                    img = 'fa-solid fa-font';
                    break;
                case 'pdf':
                    img = 'fa-regular fa-file-pdf';
                    break;
                case 'psd':
                case 'ai':
                case 'eps':
                case 'fla':
                case 'swf':
                    img = 'fa-regular fa-file-image';
                    break;
                case 'exe':
                case 'msi':
                    img = 'fa-regular fa-file';
                    break;
                case 'bat':
                    img = 'fa-solid fa-terminal';
                    break;
                default:
                    img = 'fa-solid fa-circle-info';
                    break;
            }
            return img;
        },
    },
};
</script>

<style scoped lang="scss">
#colderecha {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-height: calc(100vh - 20px);
    overflow: auto;
    padding: 10px 0px;

    @media(max-width: 400px) {
        height: 80vh;
    }

    .actionList {
        list-style: none;
        min-width: 50%;

        .tipodocumento {
            display: flex;
            flex-direction: column;
            cursor: pointer;
            padding: 10px;
            border: 2px solid #a9a9a929;
            margin-bottom: 10px;
            border-radius: 10px;
            font-weight: bold;
            transition: 0.5s;
            justify-content: flex-start;

            &:hover {
                background-color: #a9a9a929;
                border-color: #a9a9a929;
            }

            .icono {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 50px;
                height: 50px;
                background: #0985e325;
                border-radius: 10px;
                margin-right: 10px;
            }
        }
    }

    .contenedoraplicaciones {
        width: calc(100% - 5px);
        list-style: none;
        padding-inline-start: 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        gap: 2.5px;

        @media(max-width: 1500px) {
            flex-direction: column;
        }

        li {
            @media(max-width: 1500px) {
                flex-basis: calc(50% - 20px);
            }

            @media(min-width: 1500px) {
                flex-basis: calc(33.33% - 20px);
                aspect-ratio: 2/1;
            }

            /* Ajusta este valor según tus necesidades */
            box-sizing: border-box;

            div {
                display: flex;
                align-items: center;
                text-align: left;
            }

            p {
                margin: 0px;
            }
        }
    }


    .tipodocumento {
        display: flex;
        flex-direction: column;
        cursor: pointer;
        padding: 10px;
        border: 2px solid #a9a9a929;
        margin-bottom: 10px;
        border-radius: 10px;
        transition: 0.5s;
        justify-content: flex-start;

        &:hover {
            background-color: #a9a9a929;
            border-color: #a9a9a929;
        }

        .icono {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 50px;
            height: 50px;
            background: #0985e325;
            border-radius: 10px;
            margin-right: 10px;
        }

        .iconoconsulta {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 50px;
            height: 50px;
            background: #1abc9c;
            border-radius: 10px;
            margin-right: 10px;
        }
    }
}

.preview-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.navigation-controls,
.page-controls {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
}

.canvas-preview {
    border: 1px solid #ccc;
    border-radius: 5px;
}
</style>
